import Vue from 'vue';

Vue.component('index-accreditation-tech', require('./components/application/IndexAccreditationsTech').default);


// tabs
Vue.component('tab-verify', require('./components/tabs/TabVerify').default);
Vue.component('tab-evaluations', require('./components/tabs/TabEvaluations').default);
Vue.component('tab-process', require('./components/tabs/TabProcess').default);

// modal
Vue.component('modal-asign', require('./components/tabs/Modal/AsignModal').default);
Vue.component('modal-send', require('./components/tabs/Modal/SendModal').default);

Vue.component('scopes-technical-table', require('./components/form/scopes/Table').default);

// Data accreditation application

Vue.component('technical-review', require('./components/form/Index').default);
Vue.component('FormGeneralTechnical', require('./components/form/General').default);
Vue.component('FormOrganizationTechnical', require('./components/form/Organization').default);
Vue.component('OrganizationParentTechnical', require('./components/form/OrganizationParent').default);
Vue.component('OrganizationBranchTechnical', require('./components/form/OrganizationBranch').default);
Vue.component('FormRequestTechnical', require('./components/form/Request').default);
Vue.component('FormDetailTechnical', require('./components/form/Detail').default);
Vue.component('FormResponsableTechnical', require('./components/form/Responsable').default);
Vue.component('FormAnnexesTechnical', require('./components/form/Annexes').default);
Vue.component('AnnexedFileTechnical', require('./components/form/AnnexedFile').default);
Vue.component('FormCommitmentTechnical', require('./components/form/ComplianceCommitment').default);
Vue.component('FormSendRequestTechnical', require('./components/form/SendRequest').default);
Vue.component('VerifyDocumentationTechnical', require('./components/form/VerifyDocumentation').default);
Vue.component('DeclarationStartProccessTechnical', require('./components/form/DeclarationStartProccess').default);


// Team
Vue.component('technical-team', require('./components/team/Index').default);
Vue.component('planification-index', require('./components/team/PlanificationIndex').default);
Vue.component('planification-modal', require('./components/team/Modal').default);
Vue.component('objetion-modal', require('./components/team/ObjetionAnalysisModal').default);

// Team tabs
Vue.component('tab-planning', require('./components/team/Tabs/Planning').default);
Vue.component('tab-analysis', require('./components/team/Tabs/ObjectionAnalysis').default);
Vue.component('tab-formal_designation', require('./components/team/Tabs/FormalDesignationTeam').default);


// Quotation
Vue.component('technical-quotation', require('./components/quotation/Index').default);

// Quotation tabs
Vue.component('tab-stages', require('./components/quotation/Tabs/Stages').default);
Vue.component('tab-attached', require('./components/quotation/Tabs/Attached').default);
Vue.component('register-stages', require('./components/quotation/application/RegisterStages').default);

// Quotation Modals
Vue.component('code-eval-modal', require('./components/quotation/application/RegisterStageModal').default);


// Modal attached
Vue.component('modal-attached', require('./components/quotation/application/AttachedModal').default);


Vue.component('calendar-events', require('./components/quotation/application/CalendarEvents').default);
Vue.component('AddEventModal', require('./components/quotation/application/AddEventModal').default);
Vue.component('evaluation-modal', require('./components/quotation/application/ModalEvaluation').default);
Vue.component('edit-evaluation-modal', require('./components/quotation/application/EditEvaluationModal').default);

// Evaluacion documental
Vue.component('evaluation-documental-index', require('./components/documentalEvaluation/Index').default);
Vue.component('evaluation-report', require('./components/documentalEvaluation/Tabs/EvaluationReport').default);
Vue.component('evaluation-report-modal', require('./components/documentalEvaluation/Tabs/EvaluationReportModal').default);

// Aprobación del plan de evaluación
Vue.component('approval-plan-index', require('./components/approvalEvaluationPlan/Index').default);
Vue.component('evaluation-testification', require('./components/approvalEvaluationPlan/Tabs/EvaluationTestification').default);
Vue.component('approval-plan-modal', require('./components/approvalEvaluationPlan/Tabs/EvaluationTestificationModal').default);

// nonconformities

Vue.component('report-review-documentary', require('./components/nonconformities/ReportReviewDocumentary').default);
Vue.component('nonconformities-index', require('./components/nonconformities/Index').default);
Vue.component('assign-person-revision', require('./components/nonconformities/Tabs/AssignPersonToReview').default);
Vue.component('assign-person-revision-modal', require('./components/nonconformities/Tabs/AssignPersonToReviewModal').default);
Vue.component('review-corrective', require('./components/nonconformities/Tabs/ReviewCorrectiveActions').default);
Vue.component('instance-members-review', require('./components/nonconformities/Tabs/InstanceMembersReview').default);

// Corrective review
Vue.component('corrective-review-index', require('./components/correctiveReview/Index').default);
Vue.component('corrective-actions-form', require('./components/correctiveReview/CorrectiveActionsForm').default);
Vue.component('corrective-actions-modal', require('./components/correctiveReview/CorrectiveActionsFormModal').default);

// Decision

Vue.component('accreditation-resolution-index', require('./components/accreditationResolution/Index').default);

// Revisión


Vue.component('review_documentary-index', require('./components/reviewDocumentaryReport/Index').default);
Vue.component('documentary-report-index', require('./components/reviewDocumentaryReport/DocumentaryReport').default);
Vue.component('documentary-report-modal', require('./components/reviewDocumentaryReport/DocumentaryReportModal').default);
Vue.component('evaluation-plan-index', require('./components/reviewDocumentaryReport/EvaluationPlan').default);

// Decicion
Vue.component('decision-tecnical-index', require('./components/decision/Index').default);

Vue.component('decision-technical-index', require('./components/decision/Tabs/TechnicalReportFileAnalysis').default);
Vue.component('technical-analysis-report', require('./components/decision/Tabs/TechnicalReportFileAnalysisIndex').default);
Vue.component('technical-analysis-tabs', require('./components/decision/Tabs/Tabs').default);

Vue.component('director-technical-report', require('./components/decision/Tabs/DirectorTechnicalReport').default);
Vue.component('director-report-tabs', require('./components/decision/Tabs/TabsDirector').default);
Vue.component('director-area-report', require('./components/decision/Tabs/DirectorTechnicalReportIndex').default);
Vue.component('director-area-modal', require('./components/decision/Tabs/Modal').default);

// accreditationtechnical/generalTechnicalCoordination
Vue.component('general-technical-coordination-index', require('./components/generalTechnicalCoordinationReport/Index').default);

Vue.component('general-technical-coordination-report', require('./components/generalTechnicalCoordinationReport/Tabs/generalTechnicalCoordination').default);
Vue.component('general-technical-coordination-tabs', require('./components/generalTechnicalCoordinationReport/Tabs/Tabs').default);
Vue.component('general-technical-report', require('./components/generalTechnicalCoordinationReport/Tabs/generalTechnicalCoordinationIndex').default);

// Firma documento
Vue.component('signature-document-index', require('./components/signatureDocument/Index').default);

Vue.component('signature-document-tab', require('./components/signatureDocument/Tabs/SignatureDocumentIndex').default);
Vue.component('signature-document-modal', require('./components/signatureDocument/Tabs/Tabs').default);
Vue.component('signature-document-team', require('./components/signatureDocument/Tabs/SignatureDocument').default);
Vue.component('signature-annexes-team', require('./components/signatureDocument/Tabs/SamplingPlanFile').default);
Vue.component('evaluation-team-400', require('./components/signatureDocument/Tabs/EvaluationTeam').default);

// Add eval test tabs
Vue.component('add-evaltest-index', require('./components/addEvalTest/Index').default);
Vue.component('add-evaltest-tab', require('./components/addEvalTest/AddEvalTest').default);
Vue.component('register-stages-tab', require('./components/addEvalTest/EditStages').default);

Vue.component('evaluation-replanning_table', require('./components/addEvalTest/replanning/Index').default);
Vue.component('evaluation-replanning-index', require('./components/addEvalTest/replanning/PlanificationIndex').default);

Vue.component('scopest-index', require('./components/form/scopes/Index').default);
Vue.component('scopest-table', require('./components/form/scopes/Table').default);
Vue.component('scopest-modal', require('./components/form/scopes/Modal').default);


Vue.component('evaluation-team-designation-table', require('./components/evaluationTeamDesignation/Index').default);
Vue.component('evaluation-team-designation-index', require('./components/evaluationTeamDesignation/Tabs/EvaluationTeamDesignation').default);
Vue.component('evaluation-team-designation-info', require('./components/evaluationTeamDesignation/Tabs/EvaluationTeamDesignationIndex').default);
Vue.component('evaluation-team-designation-edit', require('./components/evaluationTeamDesignation/Tabs/Tab').default);

Vue.component('selection-evaltest-table', require('./components/selection/Index').default);
Vue.component('selection-evaltest-index', require('./components/selection/Tabs/Selection').default);
Vue.component('selection-evaltest-info', require('./components/selection/Tabs/SelectionIndex').default);
Vue.component('selection-evaltest-edit', require('./components/selection/Tabs/Tab').default);

// Toma de desicion
Vue.component('decision-tecnical-making-index', require('./components/makingDecision/Index').default);
Vue.component('decision-tecnical-making-detail', require('./components/makingDecision/DetailsDesicion').default);
Vue.component('decision-tecnical-making-report', require('./components/makingDecision/Tabs/TechnicalReport').default);
Vue.component('decision-tecnical-making-anexed', require('./components/makingDecision/Tabs/Anexed').default);
Vue.component('decision-tecnical-making-maintenance', require('./components/makingDecision/maintenance-plan/Index').default);

//Analisis documento de quejas 
Vue.component('analysis-complaint-document-table', require('./components/analysisComplaintdocument/Index').default);
Vue.component('analysis-complaint-document-tabs', require('./components/analysisComplaintdocument/Tabs').default);
Vue.component('analysis-complaint-document-annexed', require('./components/analysisComplaintdocument/703/Annexed').default);
Vue.component('analysis-complaint-document-complaint', require('./components/analysisComplaintdocument/703/Complaint').default);

//Planificacion miembros de equipo
Vue.component('planification-calendar-modal', require('./components/team/ModalCalendar').default);
Vue.component('planification-evaluators-modal', require('./components/team/ModalEvaluators').default);

// unificacion de procesos
Vue.component('process-unification-table', require('./components/processUnifications/Table').default);
Vue.component('process-unification-modal', require('./components/processUnifications/Modal').default);

//Modificacion de alcances acreditados
Vue.component('modify-scope-index', require('./components/modifyAccreditedScopes/Index').default);
Vue.component('modify-scope-active-tab', require('./components/modifyAccreditedScopes/TabActive').default);
Vue.component('modify-scope-process-tab', require('./components/modifyAccreditedScopes/TabProcess').default);
Vue.component('modify-scope-active-modal', require('./components/modifyAccreditedScopes/viewScope/Modal').default);
Vue.component('modify-scope-process-modal', require('./components/modifyAccreditedScopes/viewScope/ModalProcess').default);
Vue.component('modify-scope-active-edit', require('./components/modifyAccreditedScopes/editScope/Index').default);
Vue.component('modify-scope-process-edit', require('./components/modifyAccreditedScopes/editScope/IndexProcess').default);
Vue.component('modify-scope-process', require('./components/modifyAccreditedScopes/updateScope/Modal').default);

//devolver proceso
Vue.component('return-process-index', require('./components/returnProcess/Index').default);

//Informacion OEC
Vue.component('technical-info-oec', require('./components/companyInfoOec/Index').default);

//revision del plan de accion
Vue.component('index-revision-action-plan',require('./components/revisionActionPlan/Index').default);
Vue.component('list-revision-action-plan',require('./components/revisionActionPlan/tabs/ListRevisionActionPlan').default);
Vue.component('tabs-revision-action-plan',require('./components/revisionActionPlan/Tabs').default);
Vue.component('edit-revision-action-plan',require('./components/revisionActionPlan/tabs/Edit').default);

//Ajuste de informacion
Vue.component('setting-maintenance-plan-index',require('./components/settingInformation/maintenancePlan/Index').default);
Vue.component('setting-maintenance-plan-modal',require('./components/settingInformation/maintenancePlan/Modal').default);

//Ajuste de localizacion critica y unidad tecnica
Vue.component('setting-location-index',require('./components/settingInformation/location/Index').default);
Vue.component('setting-location-tab',require('./components/settingInformation/location/Location').default);

Vue.component('setting-oinsp-location-critical-index', require('./components/settingInformation/location/oinsp/critical/index').default);
Vue.component('setting-oinsp-location-critical-modal', require('./components/settingInformation/location/oinsp/critical/modal').default);

Vue.component('setting-oeny-location-physical-index', require('./components/settingInformation/location/oeny/physical/index').default);
Vue.component('setting-oeny-location-physical-modal', require('./components/settingInformation/location/oeny/physical/modal').default);

Vue.component('setting-oeyc-location-physical-index', require('./components/settingInformation/location/oeyc/physical/index').default);
Vue.component('setting-oeyc-location-physical-modal', require('./components/settingInformation/location/oeyc/physical/modal').default);

Vue.component('setting-ocln-location-physical-index', require('./components/settingInformation/location/ocln/physical/index').default);
Vue.component('setting-ocln-location-physical-modal', require('./components/settingInformation/location/ocln/physical/modal').default);

Vue.component('setting-oicc-location-physical-index', require('./components/settingInformation/location/oicc/physical/index').default);
Vue.component('setting-oicc-location-physical-modal', require('./components/settingInformation/location/oicc/physical/modal').default);

Vue.component('setting-ocsg-location-critical-index', require('./components/settingInformation/location/ocsg/critical/index').default);
Vue.component('setting-ocsg-location-critical-modal', require('./components/settingInformation/location/ocsg/critical/modal').default);

Vue.component('setting-ocpe-location-physical-index', require('./components/settingInformation/location/ocpe/physical/index').default);
Vue.component('setting-ocpe-location-physical-modal', require('./components/settingInformation/location/ocpe/physical/modal').default);

Vue.component('setting-ocpr-location-critical-index', require('./components/settingInformation/location/ocpr/critical/index').default);
Vue.component('setting-ocpr-location-critical-modal', require('./components/settingInformation/location/ocpr/critical/modal').default);

Vue.component('setting-csia-location-critical-index', require('./components/settingInformation/location/csia/critical/index').default);
Vue.component('setting-csia-location-critical-modal', require('./components/settingInformation/location/csia/critical/modal').default);

Vue.component('setting-csa-location-critical-index', require('./components/settingInformation/location/csa/critical/index').default);
Vue.component('setting-csa-location-critical-modal', require('./components/settingInformation/location/csa/critical/modal').default);

Vue.component('setting-csgas-location-critical-index', require('./components/settingInformation/location/csgas/critical/index').default);
Vue.component('setting-csgas-location-critical-modal', require('./components/settingInformation/location/csgas/critical/modal').default);

Vue.component('setting-csdm-location-critical-index', require('./components/settingInformation/location/csdm/critical/index').default);
Vue.component('setting-csdm-location-critical-modal', require('./components/settingInformation/location/csdm/critical/modal').default);

Vue.component('setting-csst-location-critical-index', require('./components/settingInformation/location/csst/critical/index').default);
Vue.component('setting-csst-location-critical-modal', require('./components/settingInformation/location/csst/critical/modal').default);

Vue.component('setting-csen-location-critical-index', require('./components/settingInformation/location/csen/critical/index').default);
Vue.component('setting-csen-location-critical-modal', require('./components/settingInformation/location/csen/critical/modal').default);

Vue.component('setting-ovv-location-critical-index', require('./components/settingInformation/location/ovv/critical/index').default);
Vue.component('setting-ovv-location-critical-modal', require('./components/settingInformation/location/ovv/critical/modal').default);

//Ajuste de documentacion
Vue.component('setting-documents-index',require('./components/settingInformation/editDocumentation/Index').default);
Vue.component('setting-documents-tab',require('./components/settingInformation/editDocumentation/Document').default);
Vue.component('setting-documents-modal',require('./components/settingInformation/editDocumentation/Modal').default);
